// Google Recaptcha V3 Site Key
export const GOOGLE_SITE_KEY = '6LcKZLAUAAAAADzHZWuL-sM6BflOmDO2m7viyNbb';

// Google Recaptcha V3 Site Secret
export const GOOGLE_SECRET_KEY = '6LcKZLAUAAAAAN6njMtI-EsQ-EQn8Ov6sfHrtkCZ';
